import { Component, Input, OnDestroy, OnInit } from "@angular/core"
import { MuxDataModel } from "../../../models/muxData.model"
import { Resource } from "../../../models/resource/resource"
import { WindowSizeService } from "../../../services/window-size.service"
import { GtmVideoJsInfo } from "../../../utils/types"
import { AddOnViewService } from "../../../services/add-on-view.service"
import { Observable, Subject } from "rxjs"
import { takeUntil, tap } from "rxjs/operators"
import { CautionFlagsService } from "../../../services/caution-flags.service"
import { routeAnimations, routeTransition } from "../../../utils/animations"

@Component({
    selector: "app-audio-resource",
    templateUrl: "./audio-resource.component.html",
    styleUrls: ["./audio-resource.component.scss"],
    host: { "[@routeTransition]": "true", "[@routeAnimations]": "false", style: "display: block;" },
    animations: [routeTransition, routeAnimations],
    standalone: false,
})
export class AudioResourceComponent implements OnInit, OnDestroy {
    @Input() resource: Resource
    muxData: MuxDataModel
    gtmVideoJsInfo: GtmVideoJsInfo
    isAddonView: boolean
    isCautionFlagContainerDisplayed: boolean

    private destroyed$: Subject<void> = new Subject<void>()

    cautionFlagDisplayObservable: Observable<boolean> =
        this.cautionFlagsService.cautionFlagDisplayObservable.pipe(
            takeUntil(this.destroyed$),
            tap((nextState: boolean) => (this.isCautionFlagContainerDisplayed = nextState))
        )

    constructor(
        public windowSize: WindowSizeService,
        public addOnService: AddOnViewService,
        private cautionFlagsService: CautionFlagsService
    ) {}

    ngOnInit() {
        this.isAddonView = this.addOnService.isAddonView
        this.muxData = this.resource.getMuxData()
        this.cautionFlagDisplayObservable.subscribe()
        this.gtmVideoJsInfo = {
            title: this.resource.selectedAsset.title,
            guid: this.resource.selectedAsset.guid,
            type: this.resource.selectedAsset.mediaType,
        }
    }

    playAudio() {
        this.cautionFlagsService.playMedia = true
    }

    ngOnDestroy() {
        this.destroyed$.next()
        this.destroyed$.complete()
    }
}
